import React, { Component } from "react";  
import { withRouter } from 'react-router-dom'
import axios from 'axios';    
import {getApiHeader, removeUserSession} from '../../../../utils/CommonFunctions';
import PlanTabs from '../PlanList/PlanTab';
import PageLoader from '../../../Loader/loader';
import PlanTabsPrepaid from '../../../public/plans/planTabs'

const SERVER_URL    = process.env.REACT_APP_SERVER_URL;  

class Recharge extends Component {

    constructor(props)
    {
        super(props);

        let activeSection = '28-day_plan';

        if(this.props && this.props.location && this.props.location.state && this.props.location.state.activeSection) 
        { 
            
            activeSection = this.props.location.state.activeSection;

        } 
        

        this.state = {
            customer_activations: [],
            account_summary : [], 
            selected_number: null,
            activeSection:activeSection,
            loading:true,
            active_status:null,
            isShowPlan: false,
            is_wme_prepaid:0,
            activation_id:""
        }
        
    }

    componentDidMount() {

        if(this.props && this.props.location && this.props.location.state && this.props.location.state.activeSection) 
        { 
            this.setState({activeSection:this.props.location.state.activeSection});
        }   

        this.getUserStatus();

        this.getActivations();

        this.setState({loading: false});

    //     const is_wme_prepaid = sessionStorage.getItem('is_wme_prepaid');
    //   if (is_wme_prepaid === '1') {
    //     this.setState({ is_wme_prepaid: 1 });
    //   }
         

    }


    // force logout --------------------------------------

    getUserStatus = async () => {
        let headers     = await getApiHeader();
        let res         = await axios.get(`${ SERVER_URL }user_status`, { headers }).then(async response => {
            
            if(response.data.data.forceLogout){
                if(response.data.data.forceLogout != 'undefined'){
                    if(response.data.data.forceLogout == '1'){
                        this.handleLogout();
                    }
                }
            }
            
        }).catch(error => {            
        });
 
    };


     handleLogout = async () => {  
        let p = new Promise(async (resolve, reject)=> {
            let headers     = await getApiHeader();
            let res         = await axios.get(`${ SERVER_URL }logout`, { headers });
            let data        = res.data.data;   
            console.log(data);
            removeUserSession();  
            resolve();

        });

        p.then(
            ()=>{ 
                    this.props.history.push("/login");
            },
            ()=>{
                alert("Error in logout");
            }
        )
    }

     // force logout --------------------------------------



    
    handleChange =  async(e) => { 
        
        var active_number = e.target.value; 
        var activeStatus = e.target.selectedOptions[0]?.getAttribute('active_status');
        var is_wme_prepaid = e.target.selectedOptions[0]?.getAttribute('is_wme_prepaid')
        let activation_id = e.target.selectedOptions[0]?.getAttribute('activation_id')
        await sessionStorage.setItem('selected_number', active_number);
        await sessionStorage.setItem('wme_activation_id', activation_id);
        this.setState({ selected_number: active_number, active_status: activeStatus, isShowPlan: true, activation_id:activation_id, is_wme_prepaid :is_wme_prepaid});
  
    }; 

    getActivations = async () => {
        let headers     = await getApiHeader();
        let res         = await axios.get(`${ SERVER_URL }user_activations`, { headers });
        let data        = res.data.data.list; 
        let selected_number = '';
        let active_status = '';
        let isShowPlan = false;
        let is_wme_prepaid = 0;
        let mobile = '';
        if(data.length > 0){
        
            // selected_number = data[0].mobile_number;
            isShowPlan = true;
            active_status = data[0].activation_status;
            is_wme_prepaid = data[0].is_wme_prepaid

            if (is_wme_prepaid == 1 || is_wme_prepaid == 2) {
                const filtered = data.filter((item) => item.is_wme_prepaid == 1 || item.is_wme_prepaid == 2);
                selected_number = filtered[0].activation_id;
                mobile = filtered[0].mobile_number;
                active_status = filtered[0].activation_status;
                await sessionStorage.setItem('selected_number', filtered[0].mobile_number);
                await sessionStorage.setItem('wme_activation_id', filtered[0].activation_id);

            } else {
                selected_number = data[0].activation_id;
                mobile = data[0].mobile_number;
                active_status = data[0].activation_status;
                await sessionStorage.setItem('selected_number', data[0].mobile_number);
                await sessionStorage.setItem('wme_activation_id', data[0].activation_id);
            }


        }else{ 
            await sessionStorage.setItem('selected_number', '');
            await sessionStorage.setItem('wme_activation_id', '');
            selected_number = '';
            active_status = '';
            is_wme_prepaid = 0;
        }
        this.setState({
            selected_number: mobile, active_status: active_status, isShowPlan,customer_activations: data,  is_wme_prepaid:is_wme_prepaid
        }); 

    };

    render() {

        let default_tab='28-day_plan';
        let extratab= window.sessionStorage.getItem("recharge");
        if(extratab=="extras_plan") {
            default_tab = "extras_plan";
            window.sessionStorage.setItem("recharge", "28-day_plan");
        }

  return (
    <>

        {(this.state.loading === true) ? <PageLoader/> : null}

        <div className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor recharge" id="kt_content"> 
            
            <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
                   
                <div className="clearfix"></div>

                <div className="row">

                    <div className="col-lg-12 col-xl-12 order-lg-1 order-xl-1">

                        <div className="kt-grid__item kt-grid__item--fluid kt-app__content">

                            <div className="kt-portlet">

                                <div className="kt-portlet__head">
                                    
                                    <div className="row" style={{width:"100%"}}>

                                        <div className="col-md-6">

                                            <div className="kt-portlet__head-label">
                                                <h3 className="kt-portlet__head-title">Recharge</h3>
                                            </div>

                                        </div>

                                        <div className="col-lg-6 col-xl-6 order-lg-6 order-xl-6 pull-right">

                                            <div className="row">

                                                <div className="col-md-6" style={{marginBottom: "0px"}}>

                                                    <span style={{float: "right",paddingTop: ".255rem",color: "#C11D6C",fontSize: "16px"}}>Please select the number to recharge from here</span>
                                                
                                                </div>
                                            
                                                <div className="col-md-6">

                                                      <div className="" style={{ marginBottom: '0' }}>
                                                           <select className="form-select custom-select kt_selectpicker" value={this.state.selected_number || ''} onChange={this.handleChange} name="activation">
                                                              {this.state.customer_activations?.map(person => <option className="m--bg-success kt-font-inverse-success"
                                                               active_status={person?.activation_status}
                                                               value={person?.mobile_number} 
                                                               is_wme_prepaid={person?.is_wme_prepaid}
                                                               activation_id={person?.activation_id}
                                                               
                                                               >
                        
                                                               {person.mobile_number}</option>)}
                                                          </select>


                                                      </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div className="kt-portlet__body" id="payment_method_container">
                                   
                                    {this.state.isShowPlan == true ? 
                                    this.state.is_wme_prepaid == 1 ?
                                    
                                    <PlanTabs activeSection={this.state.activeSection} mobileNumber={sessionStorage.getItem('selected_number')} activation_id={sessionStorage.getItem('wme_activation_id')} activeStatus={this.state.active_status} activationId={this.state.activation_id} from="recharge"/>
                                    :
                                    <PlanTabsPrepaid activeSection={this.state.activeSection} mobileNumber={sessionStorage.getItem('selected_number')} activation_id={sessionStorage.getItem('wme_activation_id')} activeStatus={this.state.active_status} from="recharge"/>
                                    : null}
                                     
                                </div>

                            </div>

                        </div>

                    </div>

                </div>

            </div>
             
        </div>
                    
	</>

   )
}
}


export default withRouter(Recharge);